import { IApplicationState } from '../../types/redux';

export const selectDictionaries = (state: IApplicationState) => state.dictionaries;
